import type { NavigationState } from '@react-navigation/routers'
import { createAppFlowReset } from './appFlowReset'

const getHistoricalPaymentBackRoutes = (
  state: NavigationState,
  orderId: number
) => {
  const activeRoutes = state.routes.slice(0, state.index + 1)
  const homeIndex = activeRoutes
    .map((route) => route.name)
    .lastIndexOf('customer/home')
  const routesFromHome = activeRoutes.slice(Math.max(homeIndex, 0))
  const hasCheckout = routesFromHome.some((route) => route.name === 'checkout')
  if (homeIndex !== -1 && !hasCheckout) {
    return routesFromHome
  }

  const candidates = routesFromHome.reverse()
  const home = candidates.find((route) => route.name === 'customer/home')
  const history = candidates.find(
    (route) => route.name === 'customer/order/history'
  )
  const details = candidates.find(
    (route) =>
      route.name === 'customer/order/details/[id]' &&
      route.params &&
      'id' in route.params &&
      String(route.params.id) === String(orderId)
  )
  return [
    home ?? { name: 'customer/home' },
    history ?? { name: 'customer/order/history' },
    details ?? {
      name: 'customer/order/details/[id]',
      params: { id: String(orderId) },
    },
  ]
}

export const createHistoricalPaymentNavigation = (
  state: NavigationState,
  orderId: number,
  paymentId: string
) => {
  const routes = [
    ...getHistoricalPaymentBackRoutes(state, orderId),
    { name: 'payment/settings/[id]', params: { id: paymentId } },
  ]

  const resetState = {
    ...state,
    index: routes.length - 1,
    routes,
    preloadedRoutes: [],
  }

  return createAppFlowReset(resetState, state.key)
}
